// extracted by mini-css-extract-plugin
export default {"button":"ADJyA6","link":"zDHo5K","container":"AwuIcq","mobileContainer":"Nv_rmW"};